// Internal features
import * as asrAnnotations from './internalResources/asrAnnotations';
import * as features from './internalResources/featureFlag';
import * as accounts from './resources/accounts';
import * as agentBuilderConversations from './resources/agentBuilderConversations';
import * as agentConfig from './resources/agentConfig';
import * as agentCreation from './resources/agentCreation';
import * as agentWizard from './resources/agentWizard';
import * as analytics from './resources/analytics';
import * as apiConfig from './resources/apiConfig';
import * as apiKeys from './resources/apiKeys';
import * as assistantBatches from './resources/assistantBatches';
import * as assistantScheduleBatches from './resources/assistantScheduleBatches';
import * as assistantTasks from './resources/assistantTasks';
import * as assistantTasksResults from './resources/assistantTasksResults';
import * as audioCache from './resources/audioCache';
import * as audit from './resources/audit';
import * as balance from './resources/balance';
import * as callReviewAnnotations from './resources/callReviewAnnotations';
import * as callReviewNotes from './resources/callReviewNotes';
import * as changeLog from './resources/changeLog';
import * as chat from './resources/chat';
// Features
import * as commandBatch from './resources/commandBatch';
import * as config from './resources/config';
import * as conversation from './resources/conversation';
import * as conversationsReviewSettings from './resources/conversationReviewSettings';
import * as customAnalytics from './resources/customAnalytics';
import * as customDashboards from './resources/customDashboards';
import * as customMetrics from './resources/customMetrics';
import * as deployedVoices from './resources/deployedVoice';
import * as deployments from './resources/deployments';
import * as disclaimer from './resources/disclaimer';
import * as drafts from './resources/draft';
import * as flows from './resources/flows';
import * as functions from './resources/functions';
import * as handoff from './resources/handoff';
import * as integrationRecords from './resources/integrationRecords';
import * as integrations from './resources/integrations';
import * as knowledgeBase from './resources/knowledgeBase';
import * as language from './resources/language';
import * as multichannelDashboards from './resources/multichannelDashboards';
import * as nebulaSettings from './resources/nebulaSettings';
import * as opentable from './resources/opentable';
import * as payments from './resources/payments';
import * as phoneNumber from './resources/phoneNumber';
import * as projection from './resources/projection';
import * as projects from './resources/projects';
import * as pronunciations from './resources/pronunciations';
import * as questionnaire from './resources/questionnaire';
import * as realTimeConfig from './resources/realTimeConfig';
import * as resourceMetrics from './resources/resourceMetrics';
import * as sampleProjects from './resources/sampleProjects';
import * as secretsManager from './resources/secretsManager';
import * as smartAnalyst from './resources/smartAnalyst';
import * as smsCredentials from './resources/smsCredentials';
import * as smsTemplates from './resources/smsTemplates';
import * as sourceHub from './resources/sourceHub';
import * as speechRecognition from './resources/speechRecognition';
import * as stopKeywords from './resources/stopKeywords';
import * as summarySettings from './resources/summarySettings';
import * as telephony from './resources/telephony';
import * as templateProjects from './resources/templateProjects';
import * as testSuite from './resources/testSuite';
import * as topics from './resources/topics';
import * as translations from './resources/translations';
import * as userManagement from './resources/userManagement';
import * as variantManagement from './resources/variantManagement';
import * as voices from './resources/voices';
import * as voiceTuningSettings from './resources/voiceTuningSettings';
import * as webRTC from './resources/webRTC';

export * as types from './types';

export const api = {
  ...agentWizard,
  ...commandBatch,
  ...drafts,
  ...accounts,
  ...agentBuilderConversations,
  ...projection,
  ...agentConfig,
  ...agentCreation,
  ...analytics,
  ...assistantBatches,
  ...assistantScheduleBatches,
  ...assistantTasks,
  ...assistantTasksResults,
  ...audioCache,
  ...asrAnnotations,
  ...balance,
  ...callReviewAnnotations,
  ...callReviewNotes,
  ...changeLog,
  ...chat,
  ...config,
  ...conversation,
  ...conversationsReviewSettings,
  ...customAnalytics,
  ...customMetrics,
  ...deployments,
  ...features,
  ...flows,
  ...functions,
  ...handoff,
  ...knowledgeBase,
  ...language,
  ...opentable,
  ...payments,
  ...phoneNumber,
  ...projects,
  ...questionnaire,
  ...sampleProjects,
  ...secretsManager,
  ...smsCredentials,
  ...smsTemplates,
  ...telephony,
  ...topics,
  ...userManagement,
  ...voiceTuningSettings,
  ...pronunciations,
  ...disclaimer,
  ...realTimeConfig,
  ...resourceMetrics,
  ...stopKeywords,
  ...speechRecognition,
  ...variantManagement,
  ...voices,
  ...deployedVoices,
  ...testSuite,
  ...smartAnalyst,
  ...customDashboards,
  ...summarySettings,
  ...multichannelDashboards,
  ...audit,
  ...sourceHub,
  ...apiConfig,
  ...apiKeys,
  ...translations,
  ...templateProjects,
  ...integrationRecords,
  ...integrations,
  ...nebulaSettings,
  ...webRTC,
};

export default api;
